import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/JobStatus';

function JobStatus() {
  return (
    <MainInfoTracLayout>
      <Content />
    </MainInfoTracLayout>
  );
}

export default JobStatus;
